import { sm3 } from 'sm-crypto'

export function hashPassword(password) {
  return sm3(String(password || ''))
}



// WEBPACK FOOTER //
// ./src/utils/crypto.js